module.exports = __webpack_public_path__ + "img/logo-xianling.b72fc668.png";